import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreSidebarModule } from '@core/components';
import { CoreCommonModule } from '@core/common.module';
import { HorizontalLayoutComponent } from './horizontal-layout.component';
import { NavbarModule } from '../../components/navbar/navbar.module';
import { ContentModule } from '../../components/content/content.module';
import { FooterModule } from '../../components/footer/footer.module';
import { MenuModule } from '../../components/menu/menu.module';
import { ChatModule } from '../../../../pages/chat/chat.module';
import { NoteModule } from '../../../../pages/Sticky Notes/note.module';

@NgModule({
    declarations: [HorizontalLayoutComponent],
    imports: [RouterModule, CoreCommonModule, ChatModule, NoteModule, CoreSidebarModule, NavbarModule, ContentModule, MenuModule, FooterModule],
  exports: [HorizontalLayoutComponent]
})
export class HorizontalLayoutModule {}
